import { gql } from '@apollo/client';

const GET_DEVICE_CLASSESS_LIST = gql`
  query GetDeviceClasses {
    deviceClasses {
      Id
      Value
      NumberDisplayName
    }
  }
`;

export default GET_DEVICE_CLASSESS_LIST;
